import LoyaltyIcon from '@mui/icons-material/Loyalty';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../../extension/interface/benefit-metadata.extension.interface';

export class CouponsV2BenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.CouponsV2;
  get Icon(): React.ComponentType<SvgIconProps> {
    return LoyaltyIcon;
  }
}
